export default __webpack_public_path__ + "static/logo.colompac-9ecbbefebd98594fa6f5af8a8da9332f.png";